import api from './baseApi';

export function getHolidays(params) {
  return api.get('/holidays/getHolidays', params);
}